import { useState, useEffect } from "react";
import { fetchContent } from "../../services/parameter.service";

const useContentAsociacionUsuarios = () => {
  const [asociacionUsuarios, setAsociacionUsuarios] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getAsociacionUsuarios = async () => {
    setIsLoading(true);

    try {
      const responseContent = await fetchContent("asociacionusuarios");
      setAsociacionUsuarios(responseContent.data.list);

      setIsLoading(false);
    } catch (error) {
      console.error(" ERROR EN useContentAsociacionUsuarios --> ", error);
    }
  };

  useEffect(() => {
    getAsociacionUsuarios();
  }, []);

  return {
    asociacionUsuarios 
  };
};

export default useContentAsociacionUsuarios;
